module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"transactions":"Buchungen","add":"Neu","back":"Zurück"},"en":{"transactions":"Transactions","add":"Add","back":"Back"}}')
  delete Component.options._Ctor
}
